import { render, staticRenderFns } from "./ModalArgEdit.vue?vue&type=template&id=1a7504bd&scoped=true"
import script from "./ModalArgEdit.vue?vue&type=script&lang=js"
export * from "./ModalArgEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalArgEdit.vue?vue&type=style&index=0&id=1a7504bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7504bd",
  null
  
)

export default component.exports